module.exports = __webpack_public_path__ + "media/audio24.2dd7fd08.mp3";